module.exports = {
  lackParameter: 'Lack Parameter',
  emptyTxt: 'No data',
  coupon: 'My Coupons'
}